// export const API_URL = "http://133.186.144.20:8000";
// export const API_URL = "http://103.218.159.31:9000";
// export const API_URL = "https://xrai-dev.store/api-coffee";
export const API_URL = "https://acoffee.shop/api-coffee";
// 테스트중일떄는 8000
// export const API_URL = "http://acoffee.shop:8000/api-coffee";
// export const API_URL = "http://api-coffee:8000";
export const API_URL2 = "https://acoffee.shop";
